import { getQueryParameterByName } from '@common/utils/getQueryParameterByName'
import type { useSearchParams } from 'react-router-dom-v7'
import { navigationService } from '../../navigation.service'

export const UserPath = {
    Google: 'Google',
    QuickBook: 'Quick Book',
}

export const getUserPath = (
    searchParams: URLSearchParams,
    setSearchParams: ReturnType<typeof useSearchParams>[1]
): string => {
    const fromQuickNavigator = getQueryParameterByName('fromQuickNavigator') === 'true'
    const userPath = fromQuickNavigator ? UserPath.QuickBook : navigationService.getPreviousPage()

    if (fromQuickNavigator) {
        searchParams.delete('fromQuickNavigator')
        setSearchParams(searchParams, { replace: true })
    }

    if (!userPath && document.referrer) {
        return UserPath.Google
    }

    return (userPath as string) ?? ''
}
